import React, { Component, useEffect } from 'react';
import ReactModal from 'react-modal';
import ReactGA from "react-ga4";
import './App.css';
//import ReactResizeDetector from 'react-resize-detector';
import Main from './Layouts/Main';

import Utility from './Utility';
import Browser from './Browser';
import Statistics from './Statistics';

let options = {
	ga: 'G-HF3ZG0N0Q6'
};

if (window.gtagId) {
	options.ga = window.gtagId;
}

if (window.auth) {
	ReactGA.initialize(options.ga, {
	  gaOptions: {
	    userId: window.auth.user_id
	  }
	});
} else {
	ReactGA.initialize(options.ga);
}

ReactModal.setAppElement('#root');

const AnnotoIntegration = () => {
	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://cdn.annoto.net/widget/latest/bootstrap.js";
		script.async = true;

		script.onload = () => {
			if (window.Annoto) {
				if (window.annotoToken) {
					window.Annoto.on('ready', function (api) {
						// Authenticate SSO User
						api.auth(window.annotoToken);
					});
				}

				const config = {
					clientId: 'eyJhbGciOiJIUzI1NiJ9.ZDI1Y2Y2NzMtNjZmYS00M2Y2LWEyMjgtNzI1M2JlOTI2ZThk.sUsG6qyipZ3LX3QCf2cWk7q3ZF_kocQJPOx9U3uNtPs',
					backend: {
						domain: "us.annoto.net"
					},
					widgets: [
						{
							player: {
								/* type of the player */
								type: 'html5',
								/* DOM element or DOM query selector of the player */
								element: '#tempvideoid'
							},
							positionElement: '#annoto-container'
						}
					],
					ux: {
						widget: {
							draggableDisabled: true,
							layout: 'sidePanel',
							fabDisable: true
						}
					}
				};

				window.Annoto.boot(config);
			}
		};

/*
      'edge' - outside the element right next to it
      'overlay' - as an overlay inside the element on it's edge
      'fixed' - fixed position on the screen edge instead of relative to the element
      'sidePanel' - non dragable side panel layout
      'sidePanelOverlay' - non dragable side panel that overlays content including controls


    */

    document.head.appendChild(script);
  }, []);

  return <div id="annoto-holder"></div>;
};


class App extends Component {
	constructor(props) {
		super(props);

		// Player app state - gets pased down to all elements
		this.state = {
			recording: false,
			siteKey: null,
			currentProduct: 0,
			products: [],
			message: false,

			// Parameters from old viewer
			version: '1.0.0',
			slidePlaceholder: '/leccap/viewer-new/images/slide-placeholder.gif',
			throttle: true,
			statsInterval: 15000,
			sendPostInterval: 15000,
			useCanvas: true,
			trackPageView: true,
			currentRecording: '',
			showPlaylist: true,

			// Header properties
			orgLogo: '',
			showSiteTitle: true,

			// Viewer defaults:
			started: false,
			firstFrameLoaded: false,
			autoplay: false,
			initialTime: 0,
			duration: 0,
			formattedDuration: '0:00',
			volume: 1,
			playbackRate: 1,
			paused: true,
			seeking: false,
			ended: false,

			// These control visible elements in the player
			supportsThumbnails: false,
			thumbnails: false,
			selectedThumbnails: [],
			controls: true,
			wordeditor: false,
			transcript: false,
			transcripteditor: false,
			search: false,

			wordChecksum: false,
			lines: [],
			showSavedLineEditsModal: false,
			showSavingLineEditsModal: false,
			storedLines: [],

			showWhiteboard: false,

			captionStatus: 'none',
			supportsCaptions: false,
			captions: false,

			supportsWhiteboard: false,

			enableAnnoto: window.annotoToken ? true : false,

			fullscreen: false,

			dimensions: {
				windowWidth: 640,
				windowHeight: 480
			},

			embed: false,

			// internal App.js display variables
			renderStats: false
		};

		// Browser capabilities
		this.state.browsercapabilities = {
			fullscreen: false
		};

		const urlParams = new URLSearchParams(window.location.search);
		if(urlParams.has("start")) {
			let startString = urlParams.get("start")
			if(isNaN(startString) || Number(startString) % 1 !== 0) {
				console.error("URL `start` parameter is not valid. It must be an integer representing seconds elapsed since the beginning of the capture.");
			} else {
				let start = Number(startString);
				console.log(`Starting at ${start}!`);
				this.state.initialTime = start;
				this.state.autoplay = true;
			}
		}

		const urlHash = window.location.hash;
 		if (urlHash.includes("#goto=")) {
 			let secondsString = urlHash.substring(6);
 			if(isNaN(secondsString) || Number(secondsString) % 1 !== 0) {
 				console.error("URL `goto` hash parameter is not valid. It must be an integer representing seconds elapsed since the beginning of the capture.");
 			} else {
 				let start = Number(secondsString);
 				console.log(`Starting at ${start}!`);
 				this.state.initialTime = start;
				this.state.autoplay = true;
 			}
 		}

		let recording_key = '',
			location = window.location.href,
			segments = location.split('/');

		for (var i = segments.length - 1; i >= 0; i--) {
			recording_key = segments[i];

			if (recording_key !== '') {
				i = -1;
			}
		}

		if (this.state.initialTime === 0) {
			let jumpToTime = Utility.localStorageGet(recording_key + '.initialTime');
			// console.log('jump to: ' + jumpToTime);
			this.state.initialTime = jumpToTime;
		}

 		let volume = Utility.localStorageGet(recording_key + '.volume');

		if (!volume || volume < 0 || volume > 1) {
			volume = 1;
		}

		this.state.volume = volume*1;

		if (document.fullscreenEnabled ||
			document.webkitFullscreenEnabled ||
			document.mozFullScreenEnabled ||
			document.msFullscreenEnabled
		) {
			this.state.browsercapabilities.fullscreen = true;
		}

		this.statsRef = React.createRef();

		// super globals - some variables should not effect state
		// minInterval used to be 1000/30, however Chrome 88+ introduced a bug that, if drawImage is called slower than the frame rate, while the video is hidden, it appears to pause the video in the background causing a choppy video
		window.appGlobals = {
			maxFPS: 30,
			minInterval: 30,
		};

	//   // if app.browser.mobile or webkitMajorVer and webkitMajorVer < 537
	//   //   #since safari is so slow pre webkit 537, just play no canvas as well!
	//   //   app.useCanvas = no

		let chrome = Browser.chrome();

		if (chrome === true) {
			this.state.throttle = false;
		}
	//   // app.throttle = yes if safari and not chrome and webkitMajorVer and webkitMajorVer >= 537

	//   // if not Modernizr.video.h264
	//   //   # If the browser does not support h.264, we will post a browser not supported message
	//   //   app.useCanvas = no

		// Check if we are embedded in an iframe
		if (window.location !== window.parent.location) {
			this.state.embed = true;
		}
	}

	resize = () => {
		let d = document,
			documentElement = d.documentElement,
			body = d.getElementsByTagName('body')[0],
			width = window.innerWidth || documentElement.clientWidth || body.clientWidth,
			height = window.innerHeight || documentElement.clientHeight || body.clientHeight,
			extraHeaderHeight = 0;

		let titleHeader = document.getElementById('title-header');

		if (titleHeader) {
			extraHeaderHeight = titleHeader.offsetHeight - 40;
		}

		this.setState({
			dimensions: {
				windowWidth: width,
				windowHeight: height,
				extraHeaderHeight: extraHeaderHeight,
				wordeditorHeight: 100,
				captionsHeight: 80,
				controlsHeight: 39,
				compactControlsHeight: 8,
				thumbnailsHeight: 152
			}
		});
	}

	componentDidMount() {
		// document.addEventListener('resize', _.debounce(this.resize, 250));
		document.addEventListener('player.resize', this.resize);
		// document.body.addEventListener('touchmove', this.preventDefault, { passive: false });

		// Fullscreen events
		document.addEventListener('player.togglefullscreen', this.toggleFullscreen);
		document.addEventListener('player.seek', this.videoseekHandler);
		document.addEventListener('player.thing.select', this.selectThingHandler);
		document.addEventListener('player.controls.seek', this.controlseekHandler);
		document.addEventListener('player.product.change', this.changeProduct);

		document.addEventListener('fullscreenchange', this.fullscreenChangeHandler);
		document.addEventListener('webkitfullscreenchange', this.fullscreenChangeHandler);
		document.addEventListener('mozfullscreenchange', this.fullscreenChangeHandler);
		document.addEventListener('MSFullscreenChange', this.fullscreenChangeHandler);

		Utility.callApiGet('product', this.handleProductResponse);

		// TODO: hrmmm, is this necessary?
		this.resize();
	}

	componentWillUnmount() {
		document.body.removeEventListener('player.resize', this.preventDefault);

		// Fullscreen events
		document.removeEventListener('player.togglefullscreen', this.toggleFullscreen);
		document.removeEventListener('player.seek', this.videoseekHandler);
		document.removeEventListener('player.thing.select', this.selectThingHandler);
		document.removeEventListener('player.controls.seek', this.controlseekHandler);
		document.removeEventListener('player.product.change', this.changeProduct);

		document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
		document.removeEventListener('webkitfullscreenchange', this.fullscreenChangeHandler);
		document.removeEventListener('mozfullscreenchange', this.fullscreenChangeHandler);
		document.removeEventListener('MSFullscreenChange', this.fullscreenChangeHandler);
	}

	changeProduct = (ev) => {
		let productIndex = ev.detail.productIndex;
		if (this.state.productIndex !== productIndex) {
			this.setState({
				autoplay: this.state.paused === false,
				initialTime: ev.detail.currentTime
			}, () => {
				// get codec ID from product index
				let codecId = this.state.products[productIndex].codec_id;
				Utility.localStorageSet(this.state.siteKey + '.preferredFormat', codecId);
				this.setupPlayer(this.state.recording, productIndex);
			})
		}
	}

	// preventDefault = (ev) => {
	// 	console.log(ev);
	// 	// On iPad, this should  prevent the layout from being moved, but
	// 	// which it does, but scrollable areas also stop working
	// 	ev.preventDefault();
	// }

	// Stats related methods
	videoseekHandler = (ev) => {
		this.statsRef.current.logEnd(ev.detail.from);
		this.statsRef.current.logStart(ev.detail.to);
	}

	handleProductResponse = (xhr) => {
		// Process our return data
		if ([403, 404, 500, 503].includes(xhr.status)) {
			// Recording not found
			var errorMessage = JSON.parse(xhr.responseText);

			if (errorMessage.solution.indexOf('@umich')) {
				errorMessage.solution = '';
			}

			this.setState({ message: errorMessage });
		}

		// Process our return data
		if (xhr.status >= 200 && xhr.status < 300) {
			// Request is successful
			var recording = JSON.parse(xhr.responseText);

			this.setState({
				siteKey: recording.sitekey,
				products: recording.info.products,
				showUnpublishedModal: !recording.published
			}, () => {
				let codecId = parseInt(Utility.localStorageGet(recording.sitekey + '.preferredFormat'), 10);

				let productIndex = 0;
				let i = 0;

				for (const product of recording.info.products) {
					if (product.codec_id === codecId) {
						productIndex = i;
					}

					i++;
				}

				this.setupPlayer(recording, productIndex);
			});
		}
	}

	setupPlayer = (recording, productIndex) => {
			// Set recording.info
			recording.info = { ...recording.info, ...this.state.products[productIndex]};

			var enabledPresets = {
					video: 0,
					slides: 0,
					legacyVideo: 0,
					aux: [],
					whiteboard: [],
					thumbnailChoices: []
				},
				thumbnails = false,
				selectedThumbnails = [],
				selectedThumbnailsCount = 0,
				visiblePresets = {
					stage: [],
					whiteboard: []
				};

			if (+recording.info.movie_exported_video_present) {
				enabledPresets.video = 1;
				visiblePresets.stage.push({
					name: 'Video',
					visible: true
				});
			}

			if (+recording.info.movie_exported_slides_present && recording.info.thumbnails) {
				enabledPresets.slides = 1;
				thumbnails = true;
				selectedThumbnails = ['slides', false];
				selectedThumbnailsCount = recording.info.thumbnails.length;

				enabledPresets.thumbnailChoices.push([
					'slides',
					false,
					'Slides'
				]);

				if (+recording.info.movie_exported_video_left > 0) {
					// Prepend
					visiblePresets.stage.unshift({
						name: 'Slides',
						visible: true
					});
				} else {
					// Append
					visiblePresets.stage.push({
						name: 'Slides',
						visible: true
					});
				}
			}

			if (enabledPresets === 0 && enabledPresets.slides === 0) {
				if (+recording.info.movie_exported_width > 0 && +recording.info.movie_exported_height > 0) {
					enabledPresets.legacyVideo = 1;
					visiblePresets.stage.push({
						name: 'Video',
						visible: true
					});
				}
			}

			// Then check to see if we have any aux or whiteboard sources
			if (recording.info.aux_sources && recording.info.aux_sources.length > 0) {
				var wsIndex = 0;
				for (var i = 0; i < recording.info.aux_sources.length; i++) {
					if (recording.info.aux_sources[i].images.length > 0) {
						// Needed to set our composite key
						switch (recording.info.aux_sources[i].kind) {
							case 'display-screen':
								enabledPresets.aux.push(recording.info.aux_sources[i]);

								// Add this source to our thumbnail list IF it has thumbnails
								if (recording.info.aux_sources[i].thumbnails.length > 0) {
									thumbnails = true;

									if (selectedThumbnails.length === 0 || (recording.info.aux_sources[i].thumbnails.length > 1 && selectedThumbnailsCount === 1)) {
										selectedThumbnails = ['a', i];
										selectedThumbnailsCount = recording.info.aux_sources[i].thumbnails.length;
									}

									enabledPresets.thumbnailChoices.push(['a', i, recording.info.aux_sources[i].name]);
								}

								visiblePresets.stage.push({
									name: recording.info.aux_sources[i].name,
									visible: true
								});
								break;
							case 'writing-surface':
								enabledPresets.whiteboard.push(recording.info.aux_sources[i]);

								if (wsIndex === 0) {
									visiblePresets.whiteboard.push({
										name: recording.info.aux_sources[i].name,
										visible: true
									});
								} else {
									visiblePresets.whiteboard.push({
										name: recording.info.aux_sources[i].name,
										visible: false
									});
								}

								// Add this source to our thumbnail list IF it has thumbnails
								if (recording.info.aux_sources[i].thumbnails.length > 0) {
									thumbnails = true;

									if (selectedThumbnails.length === 0 || (recording.info.aux_sources[i].thumbnails.length > 1 && selectedThumbnailsCount === 1)) {
										selectedThumbnails = ['w', i];
										selectedThumbnailsCount = recording.info.aux_sources[i].thumbnails.length;
									}

									enabledPresets.thumbnailChoices.push(['w', i, recording.info.aux_sources[i].name]);
								}
								wsIndex++;
								break;
							default:
								// do nothing
						}
					}
				}
			}

			if (recording.canManage === true) {
				document.documentElement.classList.add('manager');
			}

			if (this.state.embed === true) {
				thumbnails = false;
			}

			let d = document,
				documentElement = d.documentElement,
				body = d.getElementsByTagName('body')[0],
				width = window.innerWidth || documentElement.clientWidth || body.clientWidth;

			if (width < 501) {
				thumbnails = false;
			}

			var stateStuff = {
				currentProduct: productIndex,
				sendPostInterval: recording.sendPostInterval,
				showWhiteboard: recording.info.showWhiteboard,
				captionStatus: recording.info.captionStatus,
				supportsCaptions: (recording.info.captions.length > 0),
				supportsWhiteboard: (enabledPresets.whiteboard.length > 0),
				supportsThumbnails: (enabledPresets.thumbnailChoices.length > 0),
				thumbnails: thumbnails,
				selectedThumbnails: selectedThumbnails,
				enabledPresets: enabledPresets,
				visiblePresets: visiblePresets,
				baseImageUrl: recording.mediaPrefix + recording.sitekey + '/' + recording.info.slides_folder, // TODO: remove and replace with something different
				recording: recording,
				useCanvas: visiblePresets.stage.length > 1,
				renderStats: true // trigger the Statistics.js constructor
			};

			/*
				Local storage keys:
				[recording.recordingkey].lines
				[recording.recordingkey].wordHash
			*/
			// Determine whether or not words were returned
			if (recording.info.words.length > 0) {
				// Calculate a checksum on the words object - this should be identical provided the words object hasn't changed
				var wordChecksum = Utility.checksum(JSON.stringify(recording.info.words));
				this.setState({
					wordChecksum: wordChecksum
				});

				var storedWordChecksum = parseInt(Utility.localStorageGet(recording.recordingkey + '.wordHash'), 10);

				if (wordChecksum === storedWordChecksum) {
					// We have a matching checksum, so go and retrieve any stored lines
					var storedLines = Utility.localStorageGet(recording.recordingkey + '.lines');

					try {
						storedLines = JSON.parse(storedLines);

						if (storedLines.length > 0) {
							this.setState({
								showSavedLineEditsModal: true,
								storedLines: storedLines
							});
						}
					} catch(err) {
						// Unable to parse JSON, so give up!
						Utility.localStorageRemove(recording.recordingkey + '.wordHash');
						Utility.localStorageRemove(recording.recordingkey + '.lines');
					}
				} else {
					// Clear local storage
					Utility.localStorageRemove(recording.recordingkey + '.wordHash');
					Utility.localStorageRemove(recording.recordingkey + '.lines');
				}
			}

			this.setState(stateStuff);
	}

	toggleFullscreen = () => {
		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		) {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		} else {
			var root = document.getElementById('root');

			if (root.requestFullscreen) {
				root.requestFullscreen();
			} else if (root.webkitRequestFullscreen) {
				root.webkitRequestFullscreen();
			} else if (root.mozRequestFullScreen) {
				root.mozRequestFullScreen();
			} else if (root.msRequestFullscreen) {
				root.msRequestFullscreen();
			}
		}
	}

	fullscreenChangeHandler = () => {
		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		) {
			this.setState({ fullscreen: true });
		} else {
			this.setState({ fullscreen: false });
		}
	}

	updatePlayerState(params, callback) {
		if (callback) {
			this.setState(params, callback);
		} else {
			this.setState(params);
		}
	}

	selectThingHandler = (thumb) => {
		this.statsRef.current.pauseHeartbeat();
	}

	controlseekHandler = (time) => {
		// @thumbnailsView?.shouldAutoScroll = true
		this.statsRef.current.playHeartbeat();
	}

	discardEditsButtonClick = () => {
		// Clear out local storage
		Utility.localStorageRemove(this.state.recording.recordingkey + '.wordHash');
		Utility.localStorageRemove(this.state.recording.recordingkey + '.lines');
		this.setState({ showSavedLineEditsModal: false });
	}

	acknowledgeUnpublishedStateButtonClick = () => {
		this.setState({
			showUnpublishedModal: false
		});
	}

	restoreEditsButtonClick = () => {
		this.setState({
			lines: this.state.storedLines,
			showSavedLineEditsModal: false
		});
	}

	render() {
		let classNames = ['App'];

		if (Browser.mobile()) {
			classNames.push('mobile');
		}

		if (Browser.phone()) {
			classNames.push('mobile');
		}

		if (this.state.embed) {
			classNames.push('embedded');
		}

		if (this.state.enableAnnoto) {
			classNames.push('annoto');
		}

		return (
			<div className={classNames.join(' ')}>
				<Main data={this.state} updatePlayerState={this.updatePlayerState.bind(this)} />
				{this.state.enableAnnoto ? <div id="annoto-container"><AnnotoIntegration /></div> : null}
				{this.state.renderStats && <Statistics data={this.state} ref={this.statsRef} />}
				<ReactModal
					isOpen={this.state.showUnpublishedModal === true}
					contentLabel="Recording Not Published"
					onRequestClose={this.handleCloseModal}
					shouldCloseOnEsc={false}
					shouldCloseOnOverlayClick={false}
					className="modal"
					overlayClassName="modal-overlay"
					>
					<h2>Recording Not Published </h2>
					<p>This Lecture Recording has not been published. Currently, only site managers are able to access it.</p>
					<p className="smaller">To allow anyone else to view it, please publish the recording.</p>
					<div className="modal-toolbar">
						<button onClick={this.acknowledgeUnpublishedStateButtonClick}>I understand</button>
					</div>
				</ReactModal>
				<ReactModal
					isOpen={this.state.showSavingLineEditsModal}
					contentLabel="Saving Transcript Edits"
					onRequestClose={this.handleCloseModal}
					shouldCloseOnEsc={false}
					shouldCloseOnOverlayClick={false}
					className="modal"
					overlayClassName="modal-overlay"
					>
					<h2>Saving Transcript </h2>
					<p>Please wait while edits are being saved.</p>
					<p className="smaller">Do not reload this page.</p>
				</ReactModal>
				<ReactModal
					isOpen={this.state.showSavedLineEditsModal}
					contentLabel="Existing Transcript Edits"
					onRequestClose={this.handleCloseModal}
					shouldCloseOnEsc={false}
					shouldCloseOnOverlayClick={false}
					className="modal"
					overlayClassName="modal-overlay"
					>
					<h2>Unsaved Transcript Edits</h2>
					<p>Unsaved transcript edits were found - would you like to restore these edits?</p>
					<p className="smaller">Use the transcript editor to make these permanent.</p>
					<div className="modal-toolbar">
						<button className="btn-danger left" onClick={this.discardEditsButtonClick}>Discard Edits</button>
						<button className="right" onClick={this.restoreEditsButtonClick}>Restore Edits</button>
					</div>
				</ReactModal>
			</div>
		);
	}
}

export default App;
